import instance from "../axios";

const posts = {
  state: () => ({}),

  actions: {
    /**
     * Create Post
     * @param {*} t 
     * @param {*} data 
     * @returns 
     */
    async createPost(t, data) {
      const form = new FormData();
      form.append("file", data.file);
      try {
        // Update file
        const fileRes = await instance.post("posts/upload", form);
        if (fileRes.status !== 201) return { message: "photo not valid" };
        data.imgUrl = fileRes.data.data;
        // Create post
        const res = await instance.post("posts/create", data);
        return res.status;
      } catch (err) {
        return err;
      }
    },

    /**
     * Get All Post
     * @returns {array} response
     */
    async getPosts() {
      try {
        const res = await instance.get("posts");
        return res;
      } catch (err) {
        return err;
      }
    },

    /**
     * Get Post ID
     * @param {*} r 
     * @param {*} id 
     * @returns 
     */
    async getPostById(r, id) {
      try {
        const res = await instance.get(`/posts/single/${id}`);

        return res;
      } catch (err) {
        return err;
      }
    },

    /**
     * Delete Post ID
     * @param {*} t 
     * @param {*} id 
     * @returns 
     */
    async deletePostById(t, id) {
      try {
        const res = await instance.delete(`posts/${id}`);
        return res;
      } catch (err) {
        return err;
      }
    },

    /**
     * Update Post
     * @param {*} t 
     * @param {*} data 
     * @returns 
     */
    async updatePost(t, data) {
      try {
        const res = await instance.patch(`posts/update/${data.id}`, data);
        return res;
      } catch (err) {
        return err;
      }
    },
    // async getProductByType(t, type) {
    //   try {
    //     const res = await instance.get(`/posts/type/${type}`);

    //     return res;
    //   } catch (err) {
    //     return err;
    //   }
    // },


    // async updateCover(t, data) {
    //   const form = new FormData();
    //   form.append("file", data.file);

    //   try {
    //     const fRes = await instance.post("posts/upload", form);
    //     if (fRes.status !== 201) return { message: "file not valid" };

    //     console.log(fRes.data.data);

    //     const res = await instance.put(`posts/update/cover/${data.id}`, {
    //       imgUrl: fRes.data.data,
    //     });

    //     return res.status;
    //   } catch (err) {
    //     return err;
    //   }
    // },
  },
};

export default posts;
